export * from './lib/backward-confirmation.component';
export * from './lib/backward-confirmation.module';
